import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface GuestState {
    firstName?: string;
    lastName?: string;
    identity?: string;
}

export const initialState: GuestState = {};

const guestSlice = createSlice({
    name: 'guest',
    initialState,
    reducers: {
        setGuestContactInformation(
            state,
            action: PayloadAction<{ firstName: string; lastName: string; identity: string }>
        ) {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.identity = action.payload.identity;
        },
        resetGuestState() {
            return initialState;
        }
    }
});

export const { setGuestContactInformation, resetGuestState } = guestSlice.actions;
export default guestSlice.reducer;
